import { useFiltersContext } from '@/context'
import { DashboardQueries } from '@/graphql/queries/dashboard.queries'
import { SupplySectionData } from '@/types/Dashboard'

import { useGraphql } from '../useGraphql'

const useSupplySection = () => {
  const [{ marketSegmentFilter }] = useFiltersContext()
  const { marketSegmentIds } = marketSegmentFilter
  const supplySectionQuery = useGraphql<{ agmDashboard: SupplySectionData }>(
    DashboardQueries.QUERY_KEYS.getSupplySection,
    DashboardQueries.getSupplySection(),
    {
      marketSegmentIds: marketSegmentIds,
    },
    {
      enabled: !!marketSegmentIds,
    },
  )

  return supplySectionQuery
}

export default useSupplySection
